module.exports = __webpack_public_path__ + "img/output-1.ff1568ec.png";